import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLiveChatRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-live-chat',
	path: '/jira/servicedesk/projects/:projectKey/settings/live-chat',
	exact: true,
};
